$(document).ready(function() {
  var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];
 
  if(viewedProducts.length >= 2){
      $('.recently_view_title').show();
    $('.section_recently_view').show();
    console.log(viewedProducts);
    loadAjaxTemplate(viewedProducts);
      }
});

$(document).on('click', 'a.duamade_recently_view', function(e) {
  var productId = $(this).data('product-id');
  var productHandle = $(this).data('handle');

  var viewedProducts = JSON.parse(localStorage.getItem('viewed_products')) || [];
  var existingProductIndex = viewedProducts.findIndex(function(product) {
    return product.id === productId;
  });
  if (existingProductIndex !== -1) {
    viewedProducts.splice(existingProductIndex, 1);
  }
if(productHandle){
 viewedProducts.unshift(productHandle); 
}
  localStorage.setItem('viewed_products', JSON.stringify(viewedProducts));
});


function loadAjaxTemplate(viewedProducts) {

  $.ajax({
    url: '/collections/new-in?view=ajax&products=' + viewedProducts,
    method: 'GET',
    dataType: 'html',
    success: function (response) {
      // console.log(response);
      $('#recently-viewed').html(response);

      $('#recently-viewed .featured-collection__slide').each(function () {
        if ($(this).find('.placeholder-image, .product-item__image.placeholder-image').length > 0) {
          $(this).addClass('has-placeholder').hide();
        }
      });

    },
    error: function (xhr, status, error) {
      console.log(error);
    }
  });
}


